import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProspectUploadService {
  isLoadingResults: boolean = true;
  prospectsData: any = [];
  selectedCampaignId: any = '';
  selectedList: any = '';
  allLists: any = [];
  isCheckDuplicate: boolean = false;
  campaignId: any = '';
  isMoveProspectLoad = new BehaviorSubject<Boolean>(false);
  isUploadProspect = new BehaviorSubject<Boolean>(false);
  constructor() { }

  downloadSampleFile(e) {
    e.stopPropagation();
    let fileURL: any;
    fileURL = '/assets/other/Import_Sample_file.csv';
    saveAs(fileURL, 'PartnerReach-sample-file.csv');
  }
}
